import { currentValue } from '~/components/AiSearchChips/StringMatchChip/StringMatchChip.utils';
import { localizeBilledUpon, localizePricingType, localizeRecurrence, localizeStartOnType } from './services-localize';
import { billingLimitLabel, billingTimingLabel } from './ServicesChips/serviceBillingLabels';
import { hasSetValues, isBarePreapprovedExistence } from './ServicesChips/serviceConditions';
import { discountExpirationKind, discountExpirationSummary } from './ServicesChips/serviceDiscountExpiration';
import { appendPercentToBounds, summarizeDecimalRange } from './summarizeDecimalRange';
const setSegment = (set, localize)=>{
    var _ref;
    const isExclude = set.nin != null && set.nin.length > 0;
    const values = (_ref = isExclude ? set.nin : set.in) !== null && _ref !== void 0 ? _ref : [];
    if (values.length === 0) return null;
    return "".concat(isExclude ? '≠' : '').concat(values.map(localize).join('/'));
};
const directFieldSegments = (predicate, t)=>{
    var _predicate_priceIncrease, _predicate_priceIncrease1, _predicate_priceIncrease2, _predicate_limitedTimeDiscountOffer, _predicate_description;
    const segments = [];
    const name = nameSegment(predicate.name);
    if (name != null) segments.push(name);
    const pushSet = (set, localize)=>{
        if (set == null) return;
        const segment = setSegment(set, localize);
        if (segment != null) segments.push(segment);
    };
    const pushDecimal = function pushDecimal(range, label) {
        let formatBound = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (bound)=>bound;
        const bound = formatBound(summarizeDecimalRange(range));
        segments.push(bound === '' ? label : "".concat(label, " ").concat(bound));
    };
    pushSet(predicate.billedUpon, (value)=>localizeBilledUpon(t, value));
    pushSet(predicate.recurrence, (value)=>localizeRecurrence(t, value));
    pushSet(predicate.pricingType, (value)=>localizePricingType(t, value));
    if (predicate.priceMin != null) pushDecimal(predicate.priceMin, t.servicesPriceMinLabel());
    if (predicate.priceMax != null) pushDecimal(predicate.priceMax, t.servicesPriceMaxLabel());
    if (predicate.cap != null) {
        const cap = isBarePreapprovedExistence(predicate.cap) ? {} : predicate.cap;
        pushDecimal(cap, t.servicesPreapprovedAmountLabel());
    }
    const discount = predicate.discount;
    const expirationKind = discountExpirationKind(discount === null || discount === void 0 ? void 0 : discount.expiration);
    if ((discount === null || discount === void 0 ? void 0 : discount.amount) != null) pushDecimal(discount.amount, t.servicesDiscountAmountLabel());
    else if (discount != null && (expirationKind == null || hasSetValues(discount.type))) {
        segments.push(t.servicesDiscountTypeLabel());
    }
    if (expirationKind != null) segments.push(discountExpirationSummary(expirationKind, t));
    if (((_predicate_priceIncrease = predicate.priceIncrease) === null || _predicate_priceIncrease === void 0 ? void 0 : _predicate_priceIncrease.percent) != null) {
        pushDecimal(predicate.priceIncrease.percent, t.servicesPriceIncreaseLabel(), appendPercentToBounds);
    } else if (((_predicate_priceIncrease1 = predicate.priceIncrease) === null || _predicate_priceIncrease1 === void 0 ? void 0 : _predicate_priceIncrease1.exists) === false) {
        segments.push(t.servicesPriceIncreaseNoneLabel());
    } else if (predicate.priceIncrease != null && predicate.priceIncrease.startOnType == null) {
        segments.push(t.servicesPriceIncreaseExistsLabel());
    }
    const startOnType = (_predicate_priceIncrease2 = predicate.priceIncrease) === null || _predicate_priceIncrease2 === void 0 ? void 0 : _predicate_priceIncrease2.startOnType;
    if (startOnType != null) {
        const segment = setSegment(startOnType, (value)=>localizeStartOnType(t, value));
        if (segment != null) segments.push("".concat(t.servicesPriceIncreaseLabel(), " ").concat(segment));
    }
    if (((_predicate_limitedTimeDiscountOffer = predicate.limitedTimeDiscountOffer) === null || _predicate_limitedTimeDiscountOffer === void 0 ? void 0 : _predicate_limitedTimeDiscountOffer.exists) === false) {
        segments.push(t.servicesConditionalDiscountNoneLabel());
    } else if (predicate.limitedTimeDiscountOffer != null) {
        segments.push(t.servicesConditionalDiscountExistsLabel());
    }
    const maxCharges = predicate.maxCharges;
    if ((maxCharges === null || maxCharges === void 0 ? void 0 : maxCharges.limit) != null) {
        segments.push(billingLimitLabel(maxCharges.limit, t));
    } else if ((maxCharges === null || maxCharges === void 0 ? void 0 : maxCharges.exists) === false) {
        segments.push(t.servicesBillingLimitNoneLabel());
    } else if (maxCharges != null) {
        segments.push(t.servicesBillingLimitExistsLabel());
    }
    if (predicate.billUpfront != null) segments.push(billingTimingLabel(predicate.billUpfront, t));
    if (((_predicate_description = predicate.description) === null || _predicate_description === void 0 ? void 0 : _predicate_description.exists) === false) {
        segments.push(t.servicesDescriptionNoneLabel());
    } else if (predicate.description != null) {
        segments.push(t.servicesDescriptionExistsLabel());
    }
    return segments;
};
const orGroupSegment = (arms, t)=>{
    const armSummaries = arms.map((arm)=>summarizeServiceConditions(arm, t)).filter((summary)=>summary !== '');
    if (armSummaries.length === 0) return null;
    return armSummaries.join(" ".concat(t.orConnector(), " "));
};
export const nameSegment = (name)=>{
    if (name == null) return null;
    const value = currentValue(name);
    return value.trim() === '' ? null : '"'.concat(value, '"');
};
export const summarizeServiceConditions = (predicate, t)=>{
    const segments = directFieldSegments(predicate, t);
    if (predicate.or != null && predicate.or.length > 0) {
        const orSegment = orGroupSegment(predicate.or, t);
        if (orSegment != null) segments.push(orSegment);
    }
    return segments.join(', ');
};
export const summarizeServicePredicate = (predicate, t)=>{
    const conditions = summarizeServiceConditions(predicate, t);
    const base = conditions !== '' ? conditions : t.servicesLabel();
    return predicate.not != null ? "".concat(base, " …") : base;
};
